// 여러 곳에서 쓰는 범용 방향 화살표 아이콘.
// (특정 기능 패키지에 속하지 않는 공용 아이콘)

/**
 * 네 방향은 서로 정확한 회전 관계다(글리프가 viewBox 중심 대칭). 그래도 회전 대신 path 를
 * 갈아끼운다 — 내부에서 `rotate-*` 를 걸면 호출부가 className 으로 주는 transform 과 같은
 * `--tw-rotate` 를 다투고, 어느 쪽이 이길지는 Tailwind 의 빌드 산출 순서에 달려 런타임에서만
 * 드러난다. 여닫기 토글(`blog-search/category-select`)이 실제로 그 경우다.
 */
const CHEVRON_PATH = {
  up: 'm18 15-6-6-6 6',
  down: 'm6 9 6 6 6-6',
  left: 'm15 18-6-6 6-6',
  right: 'm9 18 6-6-6-6',
} as const;

export type ChevronDirection = keyof typeof CHEVRON_PATH;

export function ChevronIcon({
  direction,
  className,
}: {
  direction: ChevronDirection;
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path d={CHEVRON_PATH[direction]} />
    </svg>
  );
}
